module.exports = __webpack_public_path__ + "404-page-image-ded5638a.jpg";